module.exports = __webpack_public_path__ + "img/products-casas-rodantes.20c11a60.jpeg";